/*
 * #LAST_UPDATE 2019/10/21
 */

// Production steps of ECMA-262, Edition 5, 15.4.4.18
// Reference: http://es5.github.io/#x15.4.4.18
if (!Array.prototype.forEach) {
  Array.prototype.forEach = function(callback/*, thisArg*/) {
    var T, k;
    if (this == null) {
      throw new TypeError('this is null or not defined');
    }
    // 1. Let O be the result of calling toObject() passing the
    // |this| value as the argument.
    var O = Object(this);
    // 2. Let lenValue be the result of calling the Get() internal
    // method of O with the argument "length".
    // 3. Let len be toUint32(lenValue).
    var len = O.length >>> 0;
    // 4. If isCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function');
    }
    // 5. If thisArg was supplied, let T be thisArg; else let
    // T be undefined.
    if (arguments.length > 1) {
      T = arguments[1];
    }
    // 6. Let k be 0
    k = 0;
    // 7. Repeat, while k < len
    while (k < len) {
      var kValue;
      // a. Let Pk be ToString(k).
      //    This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty
      //    internal method of O with argument Pk.
      //    This step can be combined with c
      // c. If kPresent is true, then
      if (k in O) {
        // i. Let kValue be the result of calling the Get internal
        // method of O with argument Pk.
        kValue = O[k];
        // ii. Call the Call internal method of callback with T as
        // the this value and argument list containing kValue, k, and O.
        callback.call(T, kValue, k, O);
      }
      // d. Increase k by 1.
      k++;
    }
    // 8. return undefined
  };
}

// Reference: https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

function each(Collections, callback, thisArg) {
    var T = thisArg || this || window;
    if (Collections == null) {
        throw new TypeError("Collections is null or not defined");
    }
    if (typeof callback !== "function") {
        throw new TypeError(callback + " is not a function");
    }
    for (var i = 0; i < Collections.length; i++) {
        if (i in Collections) {
            var Element = Collections[i];
            callback.call(T, Element, i, Collections);
        }
    }
}

window.addEventListener = window.addEventListener || window.attachEvent;
window.removeEventListener = window.removeEventListener || window.detachEvent;

/*\
|*|  :: XMLHttpRequest.prototype.sendAsBinary() Polyfill ::
|*|  https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#sendAsBinary()
\*/
if (!XMLHttpRequest.prototype.sendAsBinary) {
    XMLHttpRequest.prototype.sendAsBinary = function (sData) {
        var nBytes = sData.length, ui8Data = new Uint8Array(nBytes);
        for (var nIdx = 0; nIdx < nBytes; nIdx++) {
            ui8Data[nIdx] = sData.charCodeAt(nIdx) & 0xff;
        }
        /* send as ArrayBufferView...: */
        this.send(ui8Data);
        /* ...or as ArrayBuffer (legacy)...: this.send(ui8Data.buffer); */
    };
}

if (typeof Object.assign != 'function') {
    Object.assign = function (target, varArgs) { // .length of function is 2
        'use strict';
        if (target == null) { // TypeError if undefined or null
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
            var nextSource = arguments[index];

            if (nextSource != null) { // Skip over if undefined or null
                for (var nextKey in nextSource) {
                    // Avoid bugs when hasOwnProperty is shadowed
                    if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                        to[nextKey] = nextSource[nextKey];
                    }
                }
            }
        }
        return to;
    };
}

if (!Date.now) {
    Date.now = function() {
        return new Date().getTime();
    };
}

/*
 * http://paulirish.com/2011/requestanimationframe-for-smart-animating/
 * http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-/animating
 * requestAnimationFrame polyfill by Erik Miller. fixes from Paul Irish and Tino Zijdel
 * MIT license
*/
(function() {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
                                   || window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var frameTime = 1000 / 60;
            var timeToCall = Math.max(0, frameTime - Math.abs(currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
}());
var timestamp = 0;
var rAF = window.requestAnimationFrame
       || function(fn) {
            var timenow = +new Date();
            var fps = 1000 / 60;
            var timer = Math.max(0, fps - (timenow - timestamp));
            var animation = setTimeout(fn, timer);
            timestamp = timenow + timer;
            return animation;
};
var cAF = window.cancelAnimationFrame;


// Source: https://developer.mozilla.org/en-US/docs/Web/Events/wheel
// creates a global "addWheelListener" method
// example: addWheelListener( elem, function( e )
// { console.log( e.deltaY ); e.preventDefault(); } );
(function(window,document) {

    var prefix = "", _addEventListener, support;

    // detect event model
    if ( window.addEventListener ) {
        _addEventListener = "addEventListener";
    } else {
        _addEventListener = "attachEvent";
        prefix = "on";
    }

    // detect available wheel event
    support = "onwheel" in document.createElement("div") ? "wheel" : // Modern browsers support "wheel"
              document.onmousewheel !== undefined ? "mousewheel" : // Webkit and IE support at least "mousewheel"
              "DOMMouseScroll"; // let's assume that remaining browsers are older Firefox

    window.addWheelListener = function( elem, callback, useCapture ) {
        _addWheelListener( elem, support, callback, useCapture );

        // handle MozMousePixelScroll in older Firefox
        if( support == "DOMMouseScroll" ) {
            _addWheelListener( elem, "MozMousePixelScroll", callback, useCapture );
        }
    };

    function _addWheelListener( elem, eventName, callback, useCapture ) {
        elem[ _addEventListener ]( prefix + eventName, support == "wheel" ? callback : function( originalEvent ) {
            !originalEvent && ( originalEvent = window.event );

            // create a normalized event object
            var event = {
                // keep a ref to the original event object
                originalEvent: originalEvent,
                target: originalEvent.target || originalEvent.srcElement,
                type: "wheel",
                deltaMode: originalEvent.type == "MozMousePixelScroll" ? 0 : 1,
                deltaX: 0,
                deltaZ: 0,
                preventDefault: function() {
                    originalEvent.preventDefault ?
                        originalEvent.preventDefault() :
                        originalEvent.returnValue = false;
                }
            };

            // calculate deltaY (and deltaX) according to the event
            if ( support == "mousewheel" ) {
                event.deltaY = - 1/40 * originalEvent.wheelDelta;
                // Webkit also support wheelDeltaX
                originalEvent.wheelDeltaX && ( event.deltaX = - 1/40 * originalEvent.wheelDeltaX );
            } else {
                event.deltaY = originalEvent.detail;
            }

            // it's time to fire the callback
            return callback( event );

        }, useCapture || false );
    }

})(window,document);

if (!String.prototype.substringBefore) {
    String.prototype.substringBefore = function(searchValue, repeat) {
        var re = repeat || 1;
        var str = this.toString();
        for (var i = 0; i < re; i++) {
            str = str.substring(0, str.indexOf(searchValue));
        }
        return str;
    };
}
if (!String.prototype.substringAfter) {
    String.prototype.substringAfter = function(searchValue, repeat) {
        var re = repeat || 1;
        var str = this.toString();
        for (var i = 0; i < re; i++) {
            str = str.substring(str.indexOf(searchValue) + 1);
        }
        return str;
    };
}

/*END* Polyfill global objects and functions */

/**
 *  READY TO INITIATE
 *  Use this function to initiate any actions in the components and page js
 *
 *  @param state    Defines readyState of the DOM and content,
 *                  posible values: `interactive`, `complete`, `load`.
 *  @param callback Method to call when the state is ready.
 */
function DOMInit(state, callback) {
    try {
        state = state.toLowerCase();
    } catch (ex) {}
    if (state === "load") {
        window.addEventListener("load", callback);
    } else {
        document.addEventListener("readystatechange", function() {
            if (this.readyState === state) run(callback);
        });
    }
}

/*START* Dynamic functions */

function cbTransform(arg){
    return {
        "-webkit-transform": arg,
        "-moz-transform": arg,
        "-ms-transform":arg,
        "transform": arg
    };
}
function domCbTransform(el, arg) {
    var css = cbTransform(arg);
    for (var p in css) {
        el.style[p] = css[p];
    }
}
function cbTransition(arg){
    return {
        "-webkit-transition": arg,
        "transition": arg
    };
}
function getVendorPrefix() {
    try {
        var styles = window.getComputedStyle(document.documentElement, "");
        var prefix = (Array.prototype.slice.call(styles).join("").match(/-(moz|webkit|ms)-/) || (styles.OLink === '' && ['', 'o']))[1];

        return {
            css: "-" + prefix + "-",
            js: prefix[0].toUpperCase() + prefix.substr(1)
        };
    } catch(err) {
        console.warn(err);
        return { css: "", js: "" };
    }
}

function searchWord(str, word) {
    var re = new RegExp("(\\s|^)" + word + "(\\s|$)");
    return typeof str === "string" ? str.search(re) : -1;
}
function hasClass(el, cls) {
    try {
        return searchWord(el.getAttribute("class"), cls) !== -1;
    } catch (err) {
        return false;
    }
}
function addClass(el, cls) {
    if (el && typeof cls === "string") {
        if (el.hasAttribute("class")) {
            var eCls = el.getAttribute("class");
            var re = new RegExp("(\\s|^)" + cls + "(\\s|$)");
            if (!eCls.match(re)) el.setAttribute("class", (eCls + " " + cls).trim());
        } else {
            el.setAttribute("class", cls.trim());
        }
    }
}
function addClassAll(co, cls) {
    if (co && typeof cls === "string") {
        each(co, function(el) {
            addClass(el, cls);
        });
    }
}
function removeClass(el, cls) {
    if (el && typeof cls === "string") {
        if (el.hasAttribute("class")) {
            var eCls = el.getAttribute("class");
            var re = new RegExp("(\\s|^)" + cls + "(\\s|$)", "g");
            if (eCls.match(re)) el.setAttribute("class", eCls.replace(re, " ").trim());
        }
    }
}
function removeClassAll(co, cls) {
    if (co && typeof cls === "string") {
        each(co, function(el) {
            removeClass(el, cls);
        });
    }
}
function replaceClass(el, oldCls, newCls) {
    if (el) {
        var eCls = el.getAttribute("class") || "";
        var str = newCls ? " " + newCls + " " : " ";
        if (eCls === "" || !oldCls) {
            el.setAttribute("class", (eCls + str).trim());
        } else {
            var re = new RegExp("(\\s|^)" + oldCls + "(\\s|$)", "g");
            el.setAttribute("class", eCls.replace(re, str).trim());
        }
    }
}
function replaceClassAll(co, oldCls, newCls) {
    each(co, function(el) {
        replaceClass(el, oldCls, newCls);
    });
}
function switchClassName(el, ca, cb) {
    if (el) {
        var cls = el.getAttribute("class") || "";
        if (searchWord(cls, ca) > -1) replaceClass(el, ca, cb);
        else if (searchWord(cls, cb) > -1) replaceClass(el, cb, ca);
    }
}
function switchClassElements(a, b) {
    var ac = a.getAttribute("class") || "";
    a.setAttribute("class", b.getAttribute("class") || "");
    b.setAttribute("class", ac);
}
function toggleClass(el, cls) {
    if (el) {
        if (el.hasAttribute("class")) {
            var eCls = el.getAttribute("class");
            var re = new RegExp("(\\s|^)" + cls + "(\\s|$)", "g");
            if (!eCls.match(re)) el.setAttribute("class", (eCls + " " + cls).trim());
            else el.setAttribute("class", eCls.replace(re, " ").trim());
        } else if (typeof cls === "string") {
            el.setAttribute("class", cls.trim());
        }
    }
}

function getAncestorOrSelf(child, cls) {
    return getAncestor(child, cls, true);
}
function getAncestor(child, cls, includesSelf) {
    if (includesSelf && hasClass(child, cls)) {
        return child;
    }
    var parent = child.parentElement || child.parentNode;
    if (!parent || parent.nodeName === "#document") {
        return null;
    }
    if (hasClass(parent, cls)) {
        return parent;
    } else {
        return getAncestor(parent, cls);
    }
}
function getForm(el) {
    var ctn = el.parentElement;
    return ctn.tagName === "FORM" ? ctn : getForm(ctn);
}
function getElementByName(o, name) {
    return o ? o.querySelector("[name='" + name + "']") : document.querySelector("[name='" + name + "']");
}

function getIndex(el, q) {
    if (el) {
        if (jQuery && el instanceof jQuery) {
            return el.parent().children(q).index(el);
        } else {
            var pe = el.parentElement;
            var a = !q ? pe.children : pe.querySelectorAll(q);
            for (var i = 0, j = 0; i < a.length; i++) {
                if (pe === a[i].parentElement) {
                    if (el === a[i]) return j;
                    j++;
                }
            }
            return -1;
        }
    } else {
        return -1;
    }
}

function removeArrayItem(array, item, all) {
    if (Array.isArray(array) && array.length > 0) {
        for (var i = 0; i < array.length; i++) {
            if (item === array[i]) {
                array.splice(i, 1);
                if (all) i--; else break;
            }
        }
    }
}

/* #shared
function getDataSet(el) {
    var map = {};
    if (!el.dataset) {
        var as = el.attributes;
        var tuc = function(x) { return x.substr(1).toUpperCase(); };
        for (var i = 0; i < as.length; i++) {
            var a = as[i];
            var n = a.name;
            var m = n.match(/^data-(.+)/);
            if (m) map[m[1].replace(/-([a-z])/ig, tuc)] = a.value;
        }
    } else {
        map = el.dataset;
    }
    return map;
}
function setDataSet(el, key, val) {
    if (!el.dataset) {
        var tlc = function(x) { return "-" + x.toLowerCase(); };
        var att = "data-" + key.replace(/[A-Z]/g, tlc);
        el.setAttribute(att, val);
    } else {
        el.dataset[key] = val;
    }
}
*/

function setInputValue(sel, targ) {
    var a = typeof sel === "string" ? sel : sel.value;
    document.querySelector(targ).value = a;
}
function changeValue(el, x, y, id) {
    document.getElementById(id).value = el.checked ? x : y;
}
function resetCheckbox(name) {
    var boxes = document.getElementsByName(name);
    for(var i = 0; i<boxes.length; i++) {
        if(boxes[i].checked) boxes[i].checked = false;
    }
}

function getQuery(param, search) {
    var se = search !== undefined ? search : window.location.search;
    var qs = se.replace("?", "");
    if (!param || param === "") return qs;
    if (qs === "") return null;

    var qa = qs.split("&");
    for (var i = 0; i < qa.length; i++) {
        var q = qa[i];
        if (q.indexOf("=") > -1) {
            var a = q.split("=");
            if (a[0] === param) return a[1];
        } else {
            if (q === param) return "";
        }
    }
}
function setQuery(param, value, search) {
    var se = search !== undefined ? search : window.location.search;
    var v = encodeURIComponent(value);
    if (se !== "") {
        var qa = se.replace("?", "").split("&");
        var qa2 = [];
        var isNew = true;

        for (var i = 0; i < qa.length; i++) {
            var qi = qa[i];
            var j = qi.indexOf("=");
            var qname = j > -1 ? qi.substring(0, j) : qi;
            if (qname === param) {
                if (v && v !== "") {
                    qi = param + "=" + v;
                } else {
                    qi = param;
                }
                isNew = false;
            }
            qa2.push(qi);
        }
        if (isNew) qa2.push(param + "=" + v);

        return qa2.join("&");
    } else if (v && v !== "") {
        return param + "=" + v;
    } else {
        return param;
    }
}
function removeQuery(param, search) {
    var se = search !== undefined ? search : window.location.search;
    if (!param || param === "") return se.replace("?", "");

    var qa = se.replace("?", "").split("&");
    var qa2 = [];
    for (var i = 0; i < qa.length; i++) {
        var qi = qa[i];
        var j = qi.indexOf("=");
        var qname = j > -1 ? qi.substring(0, j) : qi;

        if (qname !== param) qa2.push(qi);
    }

    return qa2.join("&");
}
function pushQueryState(q, x, state, title) {
    var qs = "";
    var url = window.location.pathname;

    if (!q || typeof q !== "string") {
        return null;
    }

    if (x === null || x === undefined) {
        qs = removeQuery(q);
    } else {
        qs = setQuery(q, x);
    }
    if (qs !== "") {
        qs = "?" + qs;
    }
    url += qs + window.location.hash;

    return window.history.pushState(state, (title ? title : q + " " + x), url);
}
function replaceQueryState(q, x, state, title) {
    var qs = "";
    var url = window.location.pathname;

    if (!q || typeof q !== "string") {
        return null;
    }

    if (x === null || x === undefined) {
        qs = removeQuery(q);
    } else {
        qs = setQuery(q, x);
    }
    if (qs !== "") {
        qs = "?" + qs;
    }
    url += qs + window.location.hash;

    return window.history.replaceState(state, (title ? title : q + " " + x), url);
}

function getElementOffset(el, parent) {
    var top  = 0;
    var left = 0;

    for (; el.offsetParent; el = el.offsetParent) {
        if (parent && el === parent) break;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    return {top: top, left: left};
}

function qs(q, ctn) {
    if (typeof q !== "string") {
        return q;
    }
    if (ctn) {
        return ctn.querySelector(q);
    } else {
        return document.querySelector(q);
    }
}
function qsa(q, ctn) {
    if (typeof q !== "string") {
        return q;
    }
    if (ctn) {
        return ctn.querySelectorAll(q);
    } else {
        return document.querySelectorAll(q);
    }
}

function bindEvent(q, type, handler, capture, callback) {
    var collections = typeof q === "string" ? qsa(q) : q;
    if (collections) {
        if (!collections.length && !(collections instanceof window.NodeList) || collections === window) {
            type.split(" ").forEach(function(eType) {
                collections.addEventListener(eType, handler, capture);
            });
        } else {
            type.split(" ").forEach(function(eType) {
                each(collections, function(el) {
                    el.addEventListener(eType, handler, capture);
                });
            });
        }
        if (callback) callback.call(collections);
    }
}
function unbindEvent(q, type, handler, capture, callback) {
    var collections = typeof q === "string" ? qsa(q) : q;
    if (collections) {
        if (!collections.length && !(collections instanceof window.NodeList) || collections === window) {
            type.split(" ").forEach(function(eType) {
                collections.removeEventListener(eType, handler, capture);
            });
        } else {
            each(collections, function(el) {
                type.split(" ").forEach(function(eType) {
                    el.removeEventListener(eType, handler, capture);
                });
            });
        }
        if (callback) callback.call(collections);
    }
}
function delegateEvent(q, type, q2, handler) {
    bindEvent(q, type, function(e) {
        var parent = this === window ? document : this;
        if (typeof q2 === "string") {
            each(qsa(q2, parent), function(el) {
                e.delegateTarget = parent;
                if (e.target === el || el.contains(e.target)) handler.call(el, e);
            });
        } else {
            each(q2, function(el) {
                if (parent.contains(el)) {
                    e.delegateTarget = parent;
                    if (e.target === el || el.contains(e.target)) handler.call(el, e);
                }
            });
        }
    }, true);
}
function delegateClick(q, q2, handler) {
    delegateEvent(q, "click", q2, handler);
}
function triggerEvent(el, etype, nobubbles, notcancelable, view) {
    var e;
    if (window.Event) {
        e = new Event(etype,  {
            view: view || window,
            bubbles: !nobubbles,
            cancelable: !notcancelable
        });
        return { event: e, triggered: el.dispatchEvent(e) };
    } else if (document.createEvent) {
        e = document.createEvent("HTMLEvents");
        e.initEvent(etype, !nobubbles, !notcancelable);
        return { event: e, triggered: el.dispatchEvent(e) };
    } else {
        e = document.createEventObject();
        e.eventType = etype;
        return { event: e, triggered: el.fireEvent("on" + etype, e) };
    }
}
function triggerMouseEvent(el, etype, nobubbles, notcancelable, view) {
    var e;
    if (window.MouseEvent) {
        e = new MouseEvent(etype,  {
            view: view || window,
            bubbles: !nobubbles,
            cancelable: !notcancelable
        });
        return { event: e, triggered: el.dispatchEvent(e) };
    } else {
        e = document.createEvent("MouseEvent");
        e.initEvent(etype, !nobubbles, !notcancelable);
        return { event: e, triggered: el.dispatchEvent(e) };
    }
}

function applyChangeCheckboxes(cb, cls) {
    var e;
    var chkd = cb.checked;
    var boxes = document.getElementsByClassName(cls);
    var box, i;

    if (document.createEvent) {
        e = document.createEvent("HTMLEvents");
        e.initEvent("change", true, true);
        for (i = 0; i < boxes.length; i++) {
            box = boxes[i];
            if (box.checked !== chkd) {
                boxes[i].checked = chkd;
                boxes[i].dispatchEvent(e);
            }
        }
    } else {
        e = document.createEventObject();
        e.eventType = "change";
        for (i = 0; i < boxes.length; i++) {
            box = boxes[i];
            if (box.checked !== chkd) {
                boxes[i].checked = chkd;
                boxes[i].fireEvent("onchange", e);
            }
        }
    }
}

function newXHR() {
    var xhr;
    if (window.XMLHttpRequest) {
        xhr = new XMLHttpRequest();
    } else {
        try {
            xhr = new ActiveXObject("Msxml2.XMLHTTP");
        } catch (e) {
            try {
                xhr = new ActiveXObject("Microsoft.XMLHTTP");
            } catch (e) {
                return null;
            }
        }
    }
    return xhr;
}
function siteAjax(url, callback, returnVar, blackout, method) {
    var xhr = newXHR();
    if (!xhr) return;
    if (blackout) ajaxBlackout(true);
    var noCache = "cache=" + Math.random();
    var nonCacheUrl = url + (url.indexOf("?") > -1 ? "&" : "?") + noCache;
    xhr.open(method ? method : "GET", nonCacheUrl, true);
    xhr.onreadystatechange = function() {
        if (this.readyState == 4) {
            if (this.status == 200) {
                if (callback) {
                    var res = this.responseText;
                    callback(res, returnVar);
                }
            } else {
                console.error(this.statusText);
                popErrorSite('errorMessageAjaxSite');
                document.getElementById('errorMessageAjaxSite').innerHTML =
                    "Error " + this.status + "! Sending request failed.";
            }
            if (blackout) ajaxBlackout(false);
        }
    };
    xhr.send(null);
}
function siteAjaxFile(oFormElement, callback) {
    function ajaxSuccess(response) {
        callback(response);
    }
    function ajaxError(status) {
        console.error(status);
        popErrorSite('errorMessageAjaxSite');
        document.getElementById('errorMessageAjaxSite').innerHTML =
            "Error " + status + "! Sending request failed.";
    }
    function ajaxComplete() {
        if (this.status === 200 && this.statusText === "OK") {
            ajaxSuccess(this.responseText);
        } else {
            ajaxError(this.status);
        }
    }
    function submitData(oData) {
        var oAjaxReq = new XMLHttpRequest();
        oAjaxReq.submittedData = oData;
        oAjaxReq.onload = ajaxComplete;
        oAjaxReq.open("post", oData.receiver, true);
        if (oData.technique === 3) {
            var sBoundary = "---------------------------" + Date.now().toString(16);
            oAjaxReq.setRequestHeader("Content-Type", "multipart\/form-data; boundary=" + sBoundary);
            oAjaxReq.sendAsBinary("--" + sBoundary + "\r\n" + oData.segments.join("--" + sBoundary + "\r\n") + "--" + sBoundary + "--\r\n");
        } else {
            oAjaxReq.setRequestHeader("Content-Type", oData.contentType);
            oAjaxReq.send(oData.segments.join(oData.technique === 2 ? "\r\n" : "&"));
        }
    }
    function processStatus(oData) {
        if (oData.status > 0) {
            return;
        }
        submitData(oData);
    }
    function pushSegment(oFREvt) {
        this.owner.segments[this.segmentIdx] += oFREvt.target.result + "\r\n";
        this.owner.status--;
        processStatus(this.owner);
    }
    function plainEscape(sText) {
        return sText.replace(/[\s\=\\]/g, "\\$&");
    }
    function SubmitRequest(oTarget) {
        var nFile, sFieldType, oField, oSegmReq, oFile, bIsPost = oTarget.method.toLowerCase() === "post";
        this.contentType = bIsPost && oTarget.enctype ? oTarget.enctype : "application\/x-www-form-urlencoded";
        this.technique = bIsPost ? this.contentType === "multipart\/form-data" ? 3 : this.contentType === "text\/plain" ? 2 : 1 : 0;
        this.receiver = oTarget.action;
        this.status = 0;
        this.segments = [];
        var fFilter = this.technique === 2 ? plainEscape : escape;
        for (var nItem = 0; nItem < oTarget.elements.length; nItem++) {
            oField = oTarget.elements[nItem];
            if (!oField.hasAttribute("name") || oField.name === "") {
                continue;
            }
            sFieldType = oField.nodeName.toUpperCase() === "INPUT" ? oField.getAttribute("type").toUpperCase() : "TEXT";
            if (sFieldType === "FILE" && oField.files.length > 0) {
                if (this.technique === 3) {
                    for (nFile = 0; nFile < oField.files.length; nFile++) {
                        oFile = oField.files[nFile];
                        oSegmReq = new FileReader();
                        oSegmReq.segmentIdx = this.segments.length;
                        oSegmReq.owner = this;
                        oSegmReq.onload = pushSegment;
                        this.segments.push("Content-Disposition: form-data; name=\"" + oField.name + "\"; filename=\"" + oFile.name + "\"\r\nContent-Type: " + oFile.type + "\r\n\r\n");
                        this.status++;
                        oSegmReq.readAsBinaryString(oFile);
                    }
                } else {
                    for (nFile = 0; nFile < oField.files.length; this.segments.push(fFilter(oField.name) + "=" + fFilter(oField.files[nFile++].name)));
                }
            }
            else if ((sFieldType !== "RADIO" && sFieldType !== "CHECKBOX") || oField.checked) {
                this.segments.push(
                        this.technique === 3 ?
                        "Content-Disposition: form-data; name=\"" + oField.name + "\"\r\n\r\n" + oField.value + "\r\n"
                        :
                        fFilter(oField.name) + "=" + fFilter(oField.value)
                        );
            }
        }
        processStatus(this);
    }

    new SubmitRequest(oFormElement);
}

/* #shared
function decodeEntities(str) {
    var ta = document.createElement("textarea");
    ta.innerHTML = str;
    return ta.value;
}
function decodeElements(els) {
    var str = "";
    if(els.length) {
        for(var i = 0; i < els.length; i++) {
            str = decodeEntities(els[i].innerHTML);
            els[i].innerHTML = str;
        }
    } else {
        str = decodeEntities(els.innerHTML);
        els.innerHTML = str;
    }
}
*/

function encryptISO(text) {
    var escapable = /[\\\"\x00-\x1f\x7f-\uffff]/g;
    var meta = {// table of character substitutions
            '\b': '\\b',
            '\t': '\\t',
            '\n': '\\n',
            '\f': '\\f',
            '\r': '\\r',
            '"' : '\\"',
            '\\': '\\\\'
        };

    function _encrypt(string) {
        escapable.lastIndex = 0;
        return escapable.test(string) ?
                string.replace(escapable, function (a) {
                    // The meta created multiple doubled backslashes, bug.
                    /*var c = meta[a];
                    return typeof c === 'string' ? c :
                            '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);*/
                    return '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
                }) :
                string;
    }

    var str = _encrypt(text);
    return str.replace(/\uFFFD/g, "");
}
function decryptISO(text) {
    return eval('"' + text + '"');
}
function doubleEncodeURI(text) {
    var str = encodeURIComponent(text);
    var re = function(a) {return new RegExp(a, 'g');};
    var eu = function(a) {return encodeURI(a);};
    str = str.replace(re('%C2%AB'), eu('%C2%AB'))
            .replace(re('%C2%BB'), eu('%C2%BB'))
            .replace(re('%C3%A6'), eu('%C3%A6'))
            .replace(re('%C3%BC'), eu('%C3%BC'))
            .replace(re('%C3%82'), eu('%C3%82'))
            .replace(re('%C3%84'), eu('%C3%84'))
            .replace(re('%C3%86'), eu('%C3%86'))
            .replace(re('%C3%8B'), eu('%C3%8B'))
            .replace(re('%C3%99'), eu('%C3%99'))
            .replace(re('%C3%9B'), eu('%C3%9B'))
            .replace(re('%C3%9C'), eu('%C3%9C'));
    return decodeURIComponent(str);
}
function encodeText(text) {
    var name = text;
    name = name.replace(/\\\\xE0/g, '\xE0')
            .replace(/\\\\xE2/g, '\xE2')
            .replace(/\\\\xE3/g, '\xE3')
            .replace(/\\\\xE4/g, '\xE4')
            .replace(/\\\\xE5/g, '\xE5')
            .replace(/\\\\xE9/g, '\xE9')
            .replace(/\\\\xE8/g, '\xE8')
            .replace(/\\\\xEA/g, '\xEA')
            .replace(/\\\\xEB/g, '\xEB')
            .replace(/\\\\xEE/g, '\xEE')
            .replace(/\\\\xEF/g, '\xEF')
            .replace(/\\\\xF1/g, '\xF1')
            .replace(/\\\\xF2/g, '\xF2')
            .replace(/\\\\xF3/g, '\xF3')
            .replace(/\\\\xF4/g, '\xF4')
            .replace(/\\\\xF6/g, '\xF6')
            .replace(/\\\\xF9/g, '\xF9')
            .replace(/\\\\xFB/g, '\xFB')
            .replace(/\\\\xE7/g, '\xE7')
            .replace(/\\\\xC0/g, '\xC0')
            .replace(/\\\\xC7/g, '\xC7')
            .replace(/\\\\xC8/g, '\xC8')
            .replace(/\\\\xC9/g, '\xC9')
            .replace(/\\\\xCA/g, '\xCA')
            .replace(/\\\\xCE/g, '\xCE')
            .replace(/\\\\xCF/g, '\xCF')
            .replace(/\\\\xD1/g, '\xD1')
            .replace(/\\\\xD4/g, '\xD4');
    return name;
}
function decodeText(text) {
    var name = text;
    name = name.replace(/\\\\xE0/g, 'à')
            .replace(/\\\\xE2/g, 'â')
            .replace(/\\\\xE8/g, 'è')
            .replace(/\\\\xE9/g, 'é')
            .replace(/\\\\xEA/g, 'ê')
            .replace(/\\\\xEB/g, 'ë')
            .replace(/\\\\xEE/g, 'î')
            .replace(/\\\\xEF/g, 'ï')
            .replace(/\\\\xE7/g, 'ç')
            .replace(/\\\\xFB/g, 'û')
            .replace(/\\\\xF4/g, 'ô')
            .replace(/\\\\xC0/g, 'À')
            .replace(/\\\\xC2/g, 'Â')
            .replace(/\\\\xC8/g, 'È')
            .replace(/\\\\xC9/g, 'É')
            .replace(/\\\\xCB/g, 'Ë')
            .replace(/\\\\xCE/g, 'Î')
            .replace(/\\\\xCF/g, '�?')
            .replace(/\\\\xC7/g, 'Ç')
            .replace(/\\\\xD4/g, 'Ô');
    return name;
}

function translateJSON(el, jsonA, jsonB) {
    var op = $(el);
    foo(jsonA, jsonB);
    op.append("<div>{</div>");
    fuu(jsonA, 1);
    op.append("<div>}</div>");

    function foo(a, b) {
        $.each(a, function (k, v) {
            if (b[k]) {
                if (typeof v === "string") {
                    a[k] = b[k];
                } else {
                    foo(v, b[k]);
                }
            }
        });
    }
    function fuu(a, lv) {
        var s = "";
        var i = 0;
        for (; i < lv * 4; i++) {s += "&nbsp;";}
        var length = 0;
        $.each(a, function () {length++;});
        $.each(a, function (k, v) {
            i++;
            var comma = i < length ? "," : "";
            var c = s + "\"" + k + "\": ";
            if (typeof v === "string") {
                c += "\"" + v + "\"" + comma;
                op.append("<div>" + c + "</div>");
            } else {
                c += "{";
                op.append("<div>" + c + "</div>");
                fuu(v, lv + 1);
                op.append("<div>" + s + "}" + comma + "</div>");
            }
        });
    }
}

function numLock(e) {
    var k = e.which || e.keyCode || e.charCode;
    // Allow: BACKSPACE, TAB, ENTER, ESCAPE, END, HOME, ARROWS, DELETE, NUMLOCK
    if ([0, 8, 9, 13, 27, 35, 36, 37, 38, 39, 40, 110, 144].indexOf(k) > -1 ||
    // Allow: Ctrl+A, Ctrl+C, Ctrl+X, Ctrl+V, Ctrl+Z, Ctrl+Y
       ([65, 67, 86, 88, 89, 90].indexOf(k) > -1 && (e.ctrlKey || e.metaKey))) {
        // keypress single quote is 39 and n is 110
        if ([39, 110].indexOf(k) > -1 && e.type === "keypress") {
            e.preventDefault();
        } else {
            return;
        }
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (k < 48 || k > 57)) &&
            ((k < 96 || k > 105) || e.type === "keypress")) {
        e.preventDefault();
    }
}
function numLockFloat(e) {
    var k = e.which || e.keyCode || e.charCode;
    // Allow: BACKSPACE, TAB, ESCAPE, END, HOME, ARROWS, ., DELETE, NUMLOCK
    if ([0, 8, 9, 27, 35, 36, 37, 38, 39, 40, 46, 110, 144].indexOf(k) > -1 ||
    // Allow: Ctrl+A, Ctrl+C, Ctrl+X, Ctrl+V, Ctrl+Z, Ctrl+Y
            [65, 67, 86, 88, 89, 90].indexOf(k) > -1 && (e.ctrlKey || e.metaKey)) {
        // Prevent more than 1 decimal point
        // keypress single quote is 39 and n is 110
        if (k === 46 && this.value.indexOf(".") > -1 ||
                [39, 110].indexOf(k) > -1 && e.type === "keypress") {
            e.preventDefault();
        } else {
            return;
        }
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (k < 48 || k > 57)) &&
            ((k < 96 || k > 105) || e.type === "keypress")) {
        e.preventDefault();
    }
}

function randomHex() {
    return Math.floor((1 + Math.random()) * 0x1000000).toString(16).substring(1);
}
function randomIdNumber(length) {
    return Math.floor((1 + Math.random()) * Math.pow(10, length ? length : 4)).toString().substring(1);
}
function randomIdLetter(length) {
    var letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    var chars = "";
    var l = length ? length : 6;
    for (var i = 0; i < l; i++) {
        chars += letters.charAt(Math.floor(Math.random() * letters.length));
    }
    return chars;
}

function formatDecimal(n, d) {
    if (isNaN(n) || (n - Math.floor(n)).length - 2 <= d) {
        return n;
    }
    var r = Math.pow(10, isNaN(d) ? 2 : d);
    return Math.round(n * r) / r;
}
function formatZeros(n, l) {
    var str = n.toString();
    var nl = str.length;
    l = l || 2;
    while (nl < l) {
        str = "0" + str;
        nl++;
    }
    return str;
}
function formatMoney($, round) {
    try {
        var lang = document.documentElement.lang,
            dec = round ? 0 : 2,
            x = isNaN($) || typeof $ === "string" ? parseFloat($.replace(",", ".")) : $,
            res = x.toFixed(dec).toString();

        return (lang === "en") ? "$" + res : res.replace(".", ",") + "$";
    } catch (err) {
        return $;
    }
}

function getLocalDateTime(date) {
    var d2 = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return d2.toISOString().replace("T", " ").substring(0, 19);
}
function getLocalDate(date) {
    var d2 = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return d2.toISOString().substring(0, 10);
}
function getLocalTime(date) {
    return date.toTimeString().substring(0, 9);
}
function getIntDateTime(y, m, d, h, mn) {
    var dt = getDateYMD(y, m, d) + formatZeros(h) + formatZeros(mn);
    return parseInt(dt);
}
function getDateYMD(y, m, d, a) {
    var im = parseInt(m) + 1;
    var array = [y, formatZeros(im), formatZeros(d)];
    return array.join(a ? a : "");
}
function getTimeHMS(h, m, s, a1, a2, a3) {
    var hasH = typeof h === "number" && h !== "";
    var hasM = typeof m === "number" && m !== "";
    var hasS = typeof s === "number" && s !== "";
    return (hasH ? formatZeros(h) + (a1 ? a1 : "") : "")
            + (hasM ? formatZeros(m) + (a2 ? a2 : "") : "")
            + (hasS ? formatZeros(s) + (a3 ? a3 : "") : "");
}
function stringDatePrefix(date, prefix) {
    return prefix + "Year=" + date.getFullYear() + "&" + prefix + "Month=" + date.getMonth() + "&" + prefix + "Day=" + date.getDate() + "&" + prefix + "Hour=" + date.getHours() + "&" + prefix + "Minute=" + date.getMinutes() + "&" + prefix + "Second=" + date.getSeconds();
}
function jsonDatePrefix(date, prefix) {
    var o = {};
    o[prefix + "Year"] = date.getFullYear();
    o[prefix + "Month"] = date.getMonth();
    o[prefix + "Day"] = date.getDate();
    o[prefix + "Hour"] = date.getHours();
    o[prefix + "Minute"] = date.getMinutes();
    o[prefix + "Second"] = date.getSeconds();
    return o;
}
function getDatePrefix(o, prefix) {
    return getDateFormatted(o[prefix + "Year"], o[prefix + "Month"], o[prefix + "Day"]);
}
function getTimePrefix(o, prefix) {
    return getTimeFormatted(o[prefix + "Hour"], o[prefix + "Minute"], o[prefix + "Second"]);
}
function getDayName(i, l) {
    var name = {"en": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"], "fr": ["dimanche", "lundi", "mardi", "mecredi", "jeudi", "vendredi", "samedi", "dimanche"]};
    return name[l ? l : lang][i];
}
function getMonthName(i, l) {
    var name = {"en": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], "fr": ["janvier", "f\xE9vrier", "mars", "avril", "mai", "juin", "juillet", "ao\xFBt", "septembre", "octobre", "novembre", "decembre"]};
    return name[l ? l : lang][i];
}
function getDateFormatted(y, m, d) {
    var im = parseInt(m);
    switch (lang) {
        case "en":
        case "fr": return d + " " + getMonthName(im) + " " + y;
        default: return y + "-" + (im + 1) + "-" + d;
    }
}
function getTimeFormatted(h, m, s) {
    if (lang === "fr") {
        return getTimeHMS(h, m, s, "h", "m", "s");
    } else {
        return getTimeHMS(h, m, s, ":", ":");
    }
}
function reformatTime(t) {
    var a = [];
    var tf = "";
    if (lang === "fr") {
        if (t.match("h")) {
            tf = t;
        } else {
            a = t.split(":");
            tf = a[0] + "h" + a[1];
            if (a.length > 2) tf += "m" + a[2] + "s";
        }
    } else {
        if (t.match(":")) {
            tf = t;
        } else {
            var ih = t.search(/h/i);
            a[0] = t.substring(0, ih);
            a[1] = t.subtring(ih + 1);
            var im = t.search(/m/i);
            if (im > -1) {
                a[1] = t.substring(ih + 1, im);
                a[2] = t.substring(im + 1, t.length - 1);
            }
            tf = a.join(":");
        }
    }
    return tf;
}

function parseFormattedDate(date, sep) {
    var a = date.split(" "),
        d = isNaN(parseInt(a[0])) ? a[1] : a[0],
        m = isNaN(parseInt(a[0])) ? a[0] : a[1],
        y = a[2];

    return getDateYMD(y, parseMonthSystem(m), d, sep);
}
function parseMonthSystem(str) {
    var listEn = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"],
        listFr = ["janvier", "f\xE9vrier", "mars", "avril", "mai", "juin", "juillet", "ao\xFBt", "septembre", "octobre", "novembre", "decembre"],
        s = str.toLowerCase();

    return listEn.indexOf(s) > -1 ? listEn.indexOf(s) : listFr.indexOf(s);
}
function roundUpTime(time) {
    var c = time.split(":"),
        h = parseInt(c[0]),
        m = parseInt(c[1]);

    m = (m - m % 15) + 15;
    if (m >= 60) {
        m = 0;
        h++;
    }
    return formatZeros(h % 24) + ":" + formatZeros(m);
}
function roundTime(time, rounder) {
    var d = time.match(/[h:]/),
        c = time.split(d),
        r = rounder ? rounder : 15,
        m = Math.round(parseInt(c[1]) / r) * r,
        h = parseInt(c[0]) + Math.floor(m / 60);

    return formatZeros(h % 24) + d + formatZeros(m % 60);
}
function nextDate(d, n, raw) {
    try {
        if (n === undefined) n = 1;
        var _ = new Date(d);
        var _d = _.getTime() + (n * 24 * 60 * 60 * 1000);
        _.setTime(_d);
        return raw ? _ : _.getFullYear() + "/" + formatZeros(_.getMonth() + 1) + "/"
                + formatZeros(_.getDate());
    } catch (ex) {
        console.log(ex);
        return null;
    }
}
function nextHour(dt, n) {
    try {
        if (n === undefined) n = 1;
        var _ = new Date(dt);
        _.setHours(_.getHours() + n);
        return _.getFullYear() + "/" + formatZeros(_.getMonth() + 1) + "/"
                + formatZeros(_.getDate()) + " " + _.toTimeString();
    } catch (ex) {
        console.log(ex);
        return null;
    }
}

/**
 * Animate Circle Loading Progress
 * Sample:
    <div class="upload-progress-ctner none">
        <div class="upload-progress">
            <svg class="upload-progress-fill" version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 100 100" xml:space="preserve">
                <path d="M50,50 L50,0 A50,50 0 0,1 50,0" fill="#7d89e0"/>
                <circle style="display:none;" cx="50%" cy="50%" r="50%" fill="#7d89e0"/>
            </svg>
            <div class="upload-progress-current">
                <span class="number">0</span>
                <span class="percent">%</span>
            </div>
            <div class="upload-progress-msg">
                <xsl:if test="$lang = 'fr'">Téléchargement</xsl:if>
                <xsl:if test="$lang = 'en'">Uploading</xsl:if>
                <div class="file-complete-output"></div>
            </div>
        </div>
    </div>
 */
function getArcXY(deg, r, c) {
    var rad, x, y;
    // https://en.wikipedia.org/wiki/Polar_coordinate_system#Converting_between_polar_and_Cartesian_coordinates
    rad = Math.PI * (deg - 90) / 180;
    x = r * Math.cos(rad) + c;
    y = r * Math.sin(rad) + c;
    return {x: x, y: y};
}
function circlePath(svg, deg) {
    var path = svg.querySelector("path"),
        circle = svg.querySelector("circle");

    if (deg < 359) {
        // Circle at center with viewbox 0 0 100 100
        var dM = "M50,50 ",
            dL = "L50,0 ",
            dA = "A50,50 0 " + Math.floor(deg / 180) + ",1 ",
            pos = getArcXY(deg, 50, 50),
            d = dM + dL + dA + pos.x + "," + pos.y + "z";

        path.setAttribute("d", d);
        path.style.display = "";
        circle.style.display = "none";
    } else {
        path.style.display = "none";
        circle.style.display = "";
    }
}
function animateCirclePath(svg, deg, deg2, d) {
    if (deg >= 360 || deg <= deg2) {
        circlePath(svg, deg);
    }
    if (deg <= deg2) {
        rAF(function() {
            animateCirclePath(svg, deg + d, deg2, d);
        });
    }
}

/* #shared
function l10n(fr, en, es) {
    var ln = lang || document.documentElement.lang;
    return ln === "fr" ? fr : ln === "es" ? es : en;
}
*/

/*END* Dynamic functions */